import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubMenuService {
  private subMenu = false;

  toggleSubMenu(): void {
    this.subMenu = !this.subMenu;
  }

  toggleSubMenuForceOpen(): void {
    this.subMenu = false;
    this.toggleSubMenu();
  }

  toggleSubMenuForceClose(): void {
    this.subMenu = true;
    this.toggleSubMenu();
  }

  isSubMenuOpen() {
    return this.subMenu;
  }
}
